/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgVehicleConstruction32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <path
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M5 20h11M27 20H16'
      />
      <mask
        id='vehicle-construction-32_svg__a'
        width={25}
        height={14}
        x={4}
        y={18}
        maskUnits='userSpaceOnUse'
      >
        <path fill='#C4C4C4' d='M29 18H4v13.3h25V18z' />
      </mask>
      <g
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        mask='url(#vehicle-construction-32_svg__a)'
      >
        <path d='M10.002 20v.265l12.019 5.302a.446.446 0 01-.018.824l-11.775 4.61a.445.445 0 00.04.844L23.001 35.5' />
        <path d='M21.999 20v.265L9.981 25.567a.446.446 0 00.017.824l11.775 4.61a.445.445 0 01-.04.844L9 35.5' />
      </g>
      <path
        fill='#fff'
        fillRule='evenodd'
        d='M7.125 16.205v1.981c0 .174.141.315.314.315h.748a.315.315 0 00.315-.315v-1.98'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M7.125 16.205v1.981c0 .174.141.315.314.315h.748a.315.315 0 00.315-.315v-1.98'
      />
      <path
        fill='#fff'
        fillRule='evenodd'
        d='M23.941 16.205v1.981a.314.314 0 00.315.315h.675a.312.312 0 00.315-.315v-1.98'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M23.941 16.205v1.981a.314.314 0 00.315.315h.675a.312.312 0 00.315-.315v-1.98'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M22.791 3.579A1.048 1.048 0 0021.854 3H10.636c-.39 0-.747.216-.928.562L7.124 8.5V16h18.123V8.5l-2.457-4.921v0z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M19.972 12.902h-7.167'
      />
      <path
        fill='#fff'
        fillRule='evenodd'
        d='M7.125 8.5c5.136.78 13.087.867 18.123 0H7.125z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M7.125 8.5c5.136.78 13.087.867 18.123 0M8 7H4.5M24.5 7h3M11.008 11.799H9.066M21.363 11.799h1.942'
      />
    </svg>
  );
}

export default SvgVehicleConstruction32;
